import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { put, takeEvery } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { EXPORT_REPORT_FAILURE, EXPORT_REPORT_SUCCESS } from './actions'

export function* exportReportSuccess() {
  yield takeEvery(EXPORT_REPORT_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      yield download(action.data, action.data.name)
    } catch (error) {
      yield put({ type: EXPORT_REPORT_FAILURE, error: error as Error })
    }
  })
}
